<template>
  <!-- 在线考试 -->
  <div class="index-conatiner" v-loading="loading">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <div class="course-container">
      <div class="condition-box">
        <div class="left-condition">
          <el-select
            @change="majorChange"
            class="c-list"
            v-model="cate_uuid"
            placeholder="选择所属专业"
          >
            <el-option
              v-for="item in majorList"
              :key="item.uuid"
              :label="item.title"
              :value="item.uuid"
            ></el-option>
          </el-select>
          <el-select
            @change="paper_typeChange"
            class="c-list"
            v-model="paper_type"
            placeholder="选择试题类型"
          >
            <el-option
              v-for="item in paperTypeList"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
          <div @click="search" class="search-box">
            <i class="iconfont el-icon-search"></i>搜索
          </div>
          <div @click="reset" class="search-box reset-box">
            <i class="iconfont el-icon-refresh"></i>重置
          </div>
        </div>
        <div class="right-tab-box">
          <div
            class="r-tab"
            :class="tabIndex === index ? 'tab-active' : ''"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabSelect(item, index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="exam-content">
        <div
          class="exam-list-box"
          @click="goTest(item)"
          v-for="(item, index) in examList"
          :key="'exam' + index"
        >
          <div
            class="list-img"
            :style="{
              backgroundImage: 'url( ' + imgUrl + item['avatar'] + ')',
            }"
          ></div>
          <div class="info-box">
            <div
              class="list-title"
              :class="item.exam_type === 1 ? 'online-type' : ''"
            >
              <span>{{ item.exam_type === 1 ? "线上" : "线下" }}</span>
              {{ item.title }}
            </div>
            <div class="date-box">
              <div class="date-text">考试时间：{{ item.create_time }}</div>
              <div class="num-text" v-if="item.exam_type === 1">
                共收录
                <span>{{ item.count_subject }}</span> 道题
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="page_size"
        :total="listTotal"
        :current-page.sync="page_index"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import bannerImg from "../components/bannerImg.vue";
import api from "../api/api";
import { imgUrl } from "../api/index";

export default {
  name: "onlineExam",
  components: {
    bannerImg,
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: "在线考试",
      majorList: [], // 所属专业
      paperTypeList: [
        {
          name: "普通试卷",
          key: 1,
        },
        {
          name: "终考",
          key: 2,
        },
      ], // 试题类型
      tabList: ["线上考试", "线下考试"],
      tabIndex: "",
      examList: [],
      listTotal: 0,
      cate_uuid: "",
      paper_type: "",
      exam_type: "",
      page_index: 1,
      page_size: 16,
      loading: true,
    };
  },
  created() {
    this.getLiveType();
    this.getExamList();
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    getExamList() {
      this.loading = true;
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        cate_uuid: this.cate_uuid,
        exam_type: this.exam_type,
        paper_type: this.paper_type,
      };
      api.getExamList(params).then((res) => {
        if (res.result) {
          this.examList = res.result.data;
          this.listTotal = res.result.total;
        }
        this.loading = false;
      });
    },
    search() {
      this.getExamList();
    },
    reset() {
      this.page_index = 1;
      (this.page_size = 10), (this.cate_uuid = "");
      (this.exam_type = ""), (this.paper_type = "");
      this.getExamList();
    },
    // 试题类型改变
    paper_typeChange() {
      this.getExamList();
    },
    // 专业改变
    majorChange() {
      this.getExamList();
    },
    // 线上线下选择
    tabSelect(item, index) {
      this.tabIndex = index;
      this.exam_type = item === "线上考试" ? "1" : "2";
      this.getExamList();
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getExamList();
    },
    // 获取专业分类
    getLiveType() {
      api.getLiveType().then((res) => {
        this.majorList = res.result;
      });
    },
    goTest(item) {
      //   this.$router.push({
      //     path: item.exam_type === 1 ? '/testOnline' : '/testOffline',
      //     query: { id: item.uuid }
      //   });
      const isLogin = localStorage.getItem("X-Access-Token");
      console.log(isLogin);
      if (!isLogin) {
        this.$message.warning("请登录！");
        location.reload();
        return;
      }
      if (item.exam_type === 1) {
        if (
          Number(item.per.substr(0, item.per.length - 1)) < 97 &&
          item.section_uuid
        ) {
          return this.$router.push({
            path: "/myCoursePlay",
            query: {
              uuid: item.section_uuid,
            },
          });
        }
        this.$router.push({
          path: "/testOnline",
          query: { id: item.uuid },
        });
      } else {
        this.$router.push({
          path: "/testOffline",
          query: {
            id: item.uuid,
            title: item.title,
            total_time: item.total_time,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-conatiner {
  margin-top: 122px;
  min-height: 600px;
}
.course-container {
  width: 73%;
  margin: 0 auto;
}
.condition-box {
  display: flex;
  justify-content: space-between;
  padding: 50px 0 36px;
  .c-list {
    margin-right: 10px;
  }
}
.left-condition {
  display: flex;
}
.search-box {
  position: relative;
  width: 80px;
  margin-right: 12px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  background-color: #f6ab2b;
  border: 1px solid #f6ab2b;
  border-radius: 18px;
  cursor: pointer;
  .iconfont {
    position: relative;
    top: 4px;
    padding-right: 4px;
  }
}
.reset-box {
  color: #f6ab2b;
  border: 1px solid #f6ab2b;
  background-color: #ffffff;
}
/deep/ .el-input--suffix .el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 18px;
}

.r-tab {
  width: 100px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  border: 1px solid #d6d6d6;
  cursor: pointer;
  &:first-child {
    border: 1px solid #d6d6d6;
    border-right: none;
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }
  &:last-child {
    border: 1px solid #d6d6d6;
    border-left: none;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
  }
  &:hover {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.right-tab-box {
  display: flex;
  border-radius: 18px;
  .tab-active {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.exam-content {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  padding-bottom: 68px;
  .exam-list-box {
    width: calc((100% - 120px) / 4);
    // min-width: 314PX;
    margin: 0 40px 44px 0;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    cursor: pointer;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:hover {
      .list-title {
        color: #ff7b1f;
      }
    }
  }
  .list-img {
    width: 100%;
    height: 210px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: antiquewhite;
  }
  .info-box {
    padding: 20px;
  }
  .list-title {
    display: flex;
    // align-items: center;
    padding-bottom: 16px;
    font-size: 16px;
    color: #3f3f3f;
    line-height: 20px;
    span {
      flex-shrink: 0;
      height: 24px;
      width: 42px;
      padding: 2px 5px;
      margin-right: 6px;
      font-size: 13px;
      color: #ffffff;
      background-color: #ff7b1f;
      border-radius: 5px;
    }
  }
  .online-type {
    span {
      background-color: #52ce0f;
    }
  }
  .date-box {
    // display: flex;
    // justify-content: space-between;
  }
  .date-text {
    font-size: 13px;
    color: #f6ab2b;
  }
  .num-text {
    font-size: 13px;
    color: #999999;
    span {
      color: #333333;
    }
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    padding-bottom: 80px;
    text-align: center;
    button {
      width: 42px;
      height: 42px;
    }
  }
  .el-pager li {
    width: 42px;
    height: 42px;
    line-height: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/onlineExam.vue